import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {Col, Row} from "react-bootstrap";
import AdvancedCombobox from "../../../primer/AdvancedCombobox";
import {setNewWorkMovement} from "../../../../_reducers/DataPanel/Payroll/payrollSlice";
import {toast} from "react-toastify";
import DateBox from "../../../primer/DateBox";
import moment from "moment";
import Dropdown from "../../../primer/Dropdown";
import {
    colorMapping,
    decimalToHourMinutesFormat,
    delayReasonOptions,
    getWorkType,
    movementTypeOptions
} from "./Components/constants";
import HourPicker from "../../../primer/HourPicker";
import TextArea from "../../../common/TextArea";
import {setSaveNewWorkMovement} from "../../../../_reducers/activitySlice";
import {isEmpty} from "../../../../_helpers/commonFunctions";
import useErganiInstallationOptions from "../../../../hooks/useErganiInstallationOptions";
import {useTranslation} from "../../../../hooks/useTranslation";

const NewWorkMovement = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const saveNewWorkMovement = useSelector((state) => state.ACTIVITY.saveNewWorkMovement);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const workMovement = useSelector((state) => state.PAYROLL.newWorkMovement);
    const payrollSettings = useSelector((state) => state.PAYROLL.payrollSettings);

    const installationOptions = useErganiInstallationOptions(false);
    const [employeeList, setEmployeeList] = useState([]);

    const employeeDropdownColumns = [
        {
            label: t('General.firstName'),
            name: "firstName",
        },
        {
            label: t('General.lastName'),
            name: "lastName",
        },
        {
            label: t('General.vatNumber'),
            name: "vatNumber",
        },
    ]

    useEffect(() => {
        loadEmployeeList("empty", setEmployeeList);
    }, [])

    const loadEmployeeList = (keyword, setData) => {
        let reqData = {
            company: company.id,
            subAccountType: "employee",
            keyword: keyword
        }
        axios.get(process.env.REACT_APP_API_URL2 + `/accounting/get-subAccount-by-word`, {
            params: reqData
        }).then(res => {
            if (res.data && res.data.status === '200') {
                if (res.data.data) {
                    if (setData) setData(res.data.data);
                } else {
                    if (setData) setData([]);
                }
            } else {
                if (setData) setData([]);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const handleOnChange = (e, type, name) => {
        if (!saveNewWorkMovement) dispatch(setSaveNewWorkMovement(true));

        if (type === "acdd") {
            if (name === "employeeName") {
                dispatch(setNewWorkMovement({
                    ...workMovement,
                    employeeName: `${e.row.firstName}|${e.row.lastName}|${e.row.vatNumber}`,
                    employeeId: e.row._id,
                    time: moment().format("HH:mm"),
                    employeeProgramData: {},
                    installationMasterId: "",
                    movementType: "arrive",
                    delayReason: "",
                    notes: "",
                }))
            }
        } else if (type === "datebox") {
            if (name === "date") {
                let changeDate = moment(e).isValid() ? e : moment().toDate();
                axios.get(`${process.env.REACT_APP_API_URL2}/payroll/employee-program-data`, {
                    headers: { "Content-Type": "application/json" },
                    params: {
                        date: moment(changeDate).format("DD/MM/YYYY"),
                        company: company.id,
                        employeeId: workMovement.employeeId,
                    }
                }).then((res) => {
                    if (res.data.status === "200") {
                        const dailyCalendar = res.data.dailyCalendar;
                        let closestTime;
                        let movementType;
                        const currentTime = moment().hour() + moment().minute() / 60;
                        dailyCalendar.forEach((el) => {
                            const arrivalDiff = Math.abs(currentTime - el.hourFrom);
                            const leaveDiff = Math.abs(currentTime - el.hourTo);

                            if (!closestTime ||  arrivalDiff < Math.abs(currentTime - closestTime) || leaveDiff < Math.abs(currentTime - closestTime)) {
                                if (arrivalDiff < leaveDiff) {
                                    closestTime = el.hourFrom;
                                    movementType = 'arrive';
                                } else if (arrivalDiff >= leaveDiff) {
                                    closestTime = el.hourTo;
                                    movementType = 'leave';
                                }
                            }
                        })
                        dispatch(setNewWorkMovement({
                            ...workMovement,
                            date: changeDate,
                            time: closestTime ? decimalToHourMinutesFormat(closestTime) : workMovement.time,
                            movementType: movementType ?? workMovement.movementType,
                            employeeProgramData: res.data.dailyCalendar,
                            installationMasterId: res.data.dailyCalendar[0]?.installationMasterId,
                        }));
                    } else {
                        console.log(res.data.message);
                        toast.error(res.data.message, {autoClose: 10000});
                    }
                }).catch((error) => {
                    console.log(error);
                    toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
                })
            }
        } else if (type === "hour-picker") {
            dispatch(setNewWorkMovement({...workMovement, [name]: e}));
        } else if (type === "textarea") {
            dispatch(setNewWorkMovement({...workMovement, [name]: e.target.value}));
        } else if (type === "dropdown") {
            dispatch(setNewWorkMovement({...workMovement, [name]: e.value}));
        }
    }

    const dailyProgramSelected = workMovement.employeeProgramData?.length > 0;
    const employeeSelected = !isEmpty(workMovement.employeeId);

    const isWorkMovementDelayed = () => {
        let diff = moment().diff(moment(workMovement.date).set({hour: Number(String(workMovement.time).split(":")[0]), minute: Number(String(workMovement.time).split(":")[1])}), "minute")
        diff = Math.abs(diff);

        return diff > 15;
    }

    const resetWorkMovement = () => {
        dispatch(setNewWorkMovement({
            ...workMovement,
            employeeName: "",
            employeeId: "",
            date: null,
            employeeProgramData: {},
            installationMasterId: "",
        }))
    }

    return (
        <React.Fragment>
            {payrollSettings.erganiCardSimulation === true && (
                <Row>
                    <Col md={4}>
                        <div>
                            <h3><u>ΚΑΤΑΣΤΑΣΗ ΕΞΟΜΟΙΩΣΗΣ</u></h3>
                        </div>
                    </Col>
                </Row>
            )}
            <Row className={"mb-3"}>
                <Col md={5}>
                    <Row>
                        <Col md={11}>
                            <AdvancedCombobox
                                name={"employeeName"}
                                className={"w-100 ac-select-dropdown"}
                                defaultValue={workMovement.employeeName}
                                label={t("General.employee")}
                                data={employeeList}
                                onChange={(e) => handleOnChange(e, "acdd", "employeeName")}
                                key={workMovement.employeeId}
                                onChangeSearch={(keyword, setData) => loadEmployeeList(keyword, setData)}
                                excludeColumns={[]}
                                columns={employeeDropdownColumns}
                                deleteEnable={false}
                                searchTableEnable={false}
                                showTableOptionOnSelect={true}
                                placeholder={t("Placeholders.selectEmployee")}
                                required={true}
                                showInsertAddButton={true}
                                hideSaveButton={true}
                                hideInsertNewRow={true}
                                inputFieldClasses="form-control"
                                isPayrollCombobox={true}
                                disabled={employeeSelected}
                            />
                        </Col>
                        <Col md={1}>
                            {employeeSelected && (
                                <button className="btn btn-default btn-sm" title="Καθαρισμός πεδίου εργαζομένου" style={{marginTop: "26px"}} onClick={() => resetWorkMovement()}><i className="fas fa-xmark"></i></button>
                            )}
                        </Col>
                    </Row>
                    {dailyProgramSelected && (
                        <Dropdown
                            name={"installationMasterId"}
                            label={t("General.installation")}
                            options={installationOptions}
                            defaultValue={installationOptions.find((el) => el.value === workMovement.employeeProgramData[0]?.installationMasterId)}
                            key={Math.random()}
                            disabled={true}
                            className={"mt-2"}
                        />
                    )}
                </Col>
                {employeeSelected && (
                    <Col md={2}>
                        <DateBox
                            name={"date"}
                            required={true}
                            label={"Ημερομηνία"}
                            selected={workMovement.date}
                            onKeyDown={(e) => e.preventDefault()}
                            onChange={(e) => handleOnChange(e, "datebox", "date")}
                        />
                        {isEmpty(workMovement.date) && <div className={"text-danger"}>Επιλέξτε ημερομηνία</div>}
                    </Col>
                )}
                {dailyProgramSelected && (
                    <Col md={5}>
                        {workMovement.employeeProgramData?.map((dc) => (
                            <div style={{
                                position: "relative",
                                display: "inline-block",
                                height: "100%",
                                width: `${(100 / workMovement.employeeProgramData.length) - 2}%`,
                                backgroundColor: colorMapping[dc.workType],
                                margin: "4px",
                                padding: "4px",
                                borderRadius: "8px",
                                textAlign: "center"
                            }}>
                                {getWorkType(dc)}<br/>
                                {dc?.allDay ? (
                                    <React.Fragment>
                                        Όλη μέρα<br/>
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        {decimalToHourMinutesFormat(dc.hourFrom)} - {decimalToHourMinutesFormat(dc.hourTo)}<br/>
                                    </React.Fragment>
                                )}
                                Εγκατάσταση: {dc.installationMasterId}
                            </div>
                        ))}
                    </Col>
                )}
            </Row>
            {dailyProgramSelected && (
                <React.Fragment>
                    <hr className={"mt-3 mb-2"}/>
                    <Row className={"mb-3"}>
                        <Col md={3}>
                            <Dropdown
                                name={"movementType"}
                                label={"Τύπος Κίνησης"}
                                options={movementTypeOptions}
                                key={Math.random()}
                                defaultValue={movementTypeOptions.find((el) => el.value === workMovement.movementType)}
                                onChange={(e) => handleOnChange(e, "dropdown", "movementType")}
                            />
                        </Col>
                        <Col md={2}>
                            <HourPicker
                                label={"Ώρα"}
                                name={"time"}
                                timeIntervals={3}
                                selected={moment(workMovement.time, "HH:mm").toDate()}
                                onChange={(e) => handleOnChange(e, "hour-picker", "time")}
                            />
                        </Col>
                        {isWorkMovementDelayed() && (
                            <Col md={3}>
                                <Dropdown
                                    name={"delayReason"}
                                    label={"Λόγος καθυστέρησης"}
                                    options={delayReasonOptions}
                                    key={Math.random()}
                                    defaultValue={delayReasonOptions.find((el) => el.value === workMovement.delayReason)}
                                    onChange={(e) => handleOnChange(e, "dropdown", "delayReason")}
                                />
                            </Col>
                        )}
                    </Row>
                    <Row>
                        <Col md={12}>
                            <TextArea
                                name={"notes"}
                                label={t("General.notes")}
                                rows={4}
                                value={workMovement.notes}
                                onChange={(e) => handleOnChange(e, "textarea", "notes")}
                            />
                        </Col>
                    </Row>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default NewWorkMovement
